/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as AboutRouteImport } from './routes/about'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAccountRouteImport } from './routes/_app/account'
import { Route as AppFriendsRouteImport } from './routes/_app/friends'
import { Route as AppGroupsRouteImport } from './routes/_app/groups'
import { Route as AppLibraryRouteImport } from './routes/_app/library'
import { Route as AppProgressRouteImport } from './routes/_app/progress'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AppAccountAboutRouteImport } from './routes/_app/account_.about'
import { Route as AppAccountGroupsRouteImport } from './routes/_app/account_.groups'
import { Route as AppAccountHelpRouteImport } from './routes/_app/account_.help'
import { Route as AppAccountRemindersRouteImport } from './routes/_app/account_.reminders'
import { Route as AppGroupsIdRouteImport } from './routes/_app/groups_.$id'
import { Route as AppInviteInviteIdRouteImport } from './routes/_app/invite.$inviteId'
import { Route as AppAccountGroupsIdRouteImport } from './routes/_app/account_.groups_.$id'
import { Route as AppAccountGroupsNewRouteImport } from './routes/_app/account_.groups_.new'
import { Route as AppExerciseKindIndexRouteImport } from './routes/_app/exercise.$kind.index'
import { Route as AppExerciseKindChooseRouteImport } from './routes/_app/exercise.$kind.choose'
import { Route as AppExerciseKindCompleteRouteImport } from './routes/_app/exercise.$kind.complete'
import { Route as AppExerciseKindIntroRouteImport } from './routes/_app/exercise.$kind.intro'
import { Route as AppExerciseKindLevelRouteImport } from './routes/_app/exercise.$kind.level'
import { Route as AppExerciseKindReadbackRouteImport } from './routes/_app/exercise.$kind.readback'
import { Route as AppGroupsIdChatRouteImport } from './routes/_app/groups_.$id_.chat'
import { Route as AppGroupsIdLeaveRouteImport } from './routes/_app/groups_.$id_.leave'
import { Route as AppGroupsIdReportRouteImport } from './routes/_app/groups_.$id_.report'
import { Route as AppInviteInviteIdJoinedRouteImport } from './routes/_app/invite.$inviteId_.joined'
import { Route as AppLibraryBookLineageUuidRouteImport } from './routes/_app/library_.book.$lineageUuid'
import { Route as AppLibraryMathCategoryRouteImport } from './routes/_app/library_.math.$category'
import { Route as AppLibraryReadingCategoryRouteImport } from './routes/_app/library_.reading.$category'
import { Route as AppAccountGroupsIdDeleteRouteImport } from './routes/_app/account_.groups_.$id_.delete'
import { Route as AppAccountGroupsIdFacilitatorRouteImport } from './routes/_app/account_.groups_.$id_.facilitator'
import { Route as AppAccountGroupsIdInviteRouteImport } from './routes/_app/account_.groups_.$id_.invite'
import { Route as AppAccountGroupsIdNameRouteImport } from './routes/_app/account_.groups_.$id_.name'
import { Route as AppAccountGroupsIdPeopleRouteImport } from './routes/_app/account_.groups_.$id_.people'
import { Route as AppLibraryMathSetLineageUuidRouteImport } from './routes/_app/library_.math.set.$lineageUuid'
import { Route as AppAccountGroupsIdInviteAccessRouteImport } from './routes/_app/account_.groups_.$id_.invite_.access'
import { Route as AppAccountGroupsIdInviteSentRouteImport } from './routes/_app/account_.groups_.$id_.invite_.sent'
import { Route as AppAccountGroupsIdMemberPersonIdRouteImport } from './routes/_app/account_.groups_.$id_.member.$personId'
import { Route as AppAccountGroupsIdInviteInviteIdWithdrawRouteImport } from './routes/_app/account_.groups_.$id_.invite_.$inviteId.withdraw'
import { Route as AppAccountGroupsIdMemberPersonIdAccessRouteImport } from './routes/_app/account_.groups_.$id_.member.$personId_.access'
import { Route as AppAccountGroupsIdMemberPersonIdRemoveRouteImport } from './routes/_app/account_.groups_.$id_.member.$personId_.remove'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRoute = AppAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppRoute,
} as any)
const AppFriendsRoute = AppFriendsRouteImport.update({
  id: '/friends',
  path: '/friends',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsRoute = AppGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryRoute = AppLibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => AppRoute,
} as any)
const AppProgressRoute = AppProgressRouteImport.update({
  id: '/progress',
  path: '/progress',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAccountAboutRoute = AppAccountAboutRouteImport.update({
  id: '/account_/about',
  path: '/account/about',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountGroupsRoute = AppAccountGroupsRouteImport.update({
  id: '/account_/groups',
  path: '/account/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountHelpRoute = AppAccountHelpRouteImport.update({
  id: '/account_/help',
  path: '/account/help',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountRemindersRoute = AppAccountRemindersRouteImport.update({
  id: '/account_/reminders',
  path: '/account/reminders',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIdRoute = AppGroupsIdRouteImport.update({
  id: '/groups_/$id',
  path: '/groups/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppInviteInviteIdRoute = AppInviteInviteIdRouteImport.update({
  id: '/invite/$inviteId',
  path: '/invite/$inviteId',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountGroupsIdRoute = AppAccountGroupsIdRouteImport.update({
  id: '/account_/groups_/$id',
  path: '/account/groups/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountGroupsNewRoute = AppAccountGroupsNewRouteImport.update({
  id: '/account_/groups_/new',
  path: '/account/groups/new',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindIndexRoute = AppExerciseKindIndexRouteImport.update({
  id: '/exercise/$kind/',
  path: '/exercise/$kind/',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindChooseRoute = AppExerciseKindChooseRouteImport.update({
  id: '/exercise/$kind/choose',
  path: '/exercise/$kind/choose',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindCompleteRoute = AppExerciseKindCompleteRouteImport.update({
  id: '/exercise/$kind/complete',
  path: '/exercise/$kind/complete',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindIntroRoute = AppExerciseKindIntroRouteImport.update({
  id: '/exercise/$kind/intro',
  path: '/exercise/$kind/intro',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindLevelRoute = AppExerciseKindLevelRouteImport.update({
  id: '/exercise/$kind/level',
  path: '/exercise/$kind/level',
  getParentRoute: () => AppRoute,
} as any)
const AppExerciseKindReadbackRoute = AppExerciseKindReadbackRouteImport.update({
  id: '/exercise/$kind/readback',
  path: '/exercise/$kind/readback',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIdChatRoute = AppGroupsIdChatRouteImport.update({
  id: '/groups_/$id_/chat',
  path: '/groups/$id/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIdLeaveRoute = AppGroupsIdLeaveRouteImport.update({
  id: '/groups_/$id_/leave',
  path: '/groups/$id/leave',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsIdReportRoute = AppGroupsIdReportRouteImport.update({
  id: '/groups_/$id_/report',
  path: '/groups/$id/report',
  getParentRoute: () => AppRoute,
} as any)
const AppInviteInviteIdJoinedRoute = AppInviteInviteIdJoinedRouteImport.update({
  id: '/invite/$inviteId_/joined',
  path: '/invite/$inviteId/joined',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryBookLineageUuidRoute =
  AppLibraryBookLineageUuidRouteImport.update({
    id: '/library_/book/$lineageUuid',
    path: '/library/book/$lineageUuid',
    getParentRoute: () => AppRoute,
  } as any)
const AppLibraryMathCategoryRoute = AppLibraryMathCategoryRouteImport.update({
  id: '/library_/math/$category',
  path: '/library/math/$category',
  getParentRoute: () => AppRoute,
} as any)
const AppLibraryReadingCategoryRoute =
  AppLibraryReadingCategoryRouteImport.update({
    id: '/library_/reading/$category',
    path: '/library/reading/$category',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdDeleteRoute =
  AppAccountGroupsIdDeleteRouteImport.update({
    id: '/account_/groups_/$id_/delete',
    path: '/account/groups/$id/delete',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdFacilitatorRoute =
  AppAccountGroupsIdFacilitatorRouteImport.update({
    id: '/account_/groups_/$id_/facilitator',
    path: '/account/groups/$id/facilitator',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdInviteRoute =
  AppAccountGroupsIdInviteRouteImport.update({
    id: '/account_/groups_/$id_/invite',
    path: '/account/groups/$id/invite',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdNameRoute = AppAccountGroupsIdNameRouteImport.update({
  id: '/account_/groups_/$id_/name',
  path: '/account/groups/$id/name',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountGroupsIdPeopleRoute =
  AppAccountGroupsIdPeopleRouteImport.update({
    id: '/account_/groups_/$id_/people',
    path: '/account/groups/$id/people',
    getParentRoute: () => AppRoute,
  } as any)
const AppLibraryMathSetLineageUuidRoute =
  AppLibraryMathSetLineageUuidRouteImport.update({
    id: '/library_/math/set/$lineageUuid',
    path: '/library/math/set/$lineageUuid',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdInviteAccessRoute =
  AppAccountGroupsIdInviteAccessRouteImport.update({
    id: '/account_/groups_/$id_/invite_/access',
    path: '/account/groups/$id/invite/access',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdInviteSentRoute =
  AppAccountGroupsIdInviteSentRouteImport.update({
    id: '/account_/groups_/$id_/invite_/sent',
    path: '/account/groups/$id/invite/sent',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdMemberPersonIdRoute =
  AppAccountGroupsIdMemberPersonIdRouteImport.update({
    id: '/account_/groups_/$id_/member/$personId',
    path: '/account/groups/$id/member/$personId',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdInviteInviteIdWithdrawRoute =
  AppAccountGroupsIdInviteInviteIdWithdrawRouteImport.update({
    id: '/account_/groups_/$id_/invite_/$inviteId/withdraw',
    path: '/account/groups/$id/invite/$inviteId/withdraw',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdMemberPersonIdAccessRoute =
  AppAccountGroupsIdMemberPersonIdAccessRouteImport.update({
    id: '/account_/groups_/$id_/member/$personId_/access',
    path: '/account/groups/$id/member/$personId/access',
    getParentRoute: () => AppRoute,
  } as any)
const AppAccountGroupsIdMemberPersonIdRemoveRoute =
  AppAccountGroupsIdMemberPersonIdRemoveRouteImport.update({
    id: '/account_/groups_/$id_/member/$personId_/remove',
    path: '/account/groups/$id/member/$personId/remove',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/about': typeof AboutRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/account': typeof AppAccountRoute
  '/friends': typeof AppFriendsRoute
  '/groups': typeof AppGroupsRoute
  '/library': typeof AppLibraryRoute
  '/progress': typeof AppProgressRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/account/about': typeof AppAccountAboutRoute
  '/account/groups': typeof AppAccountGroupsRoute
  '/account/help': typeof AppAccountHelpRoute
  '/account/reminders': typeof AppAccountRemindersRoute
  '/groups/$id': typeof AppGroupsIdRoute
  '/invite/$inviteId': typeof AppInviteInviteIdRoute
  '/account/groups/$id': typeof AppAccountGroupsIdRoute
  '/account/groups/new': typeof AppAccountGroupsNewRoute
  '/exercise/$kind/choose': typeof AppExerciseKindChooseRoute
  '/exercise/$kind/complete': typeof AppExerciseKindCompleteRoute
  '/exercise/$kind/intro': typeof AppExerciseKindIntroRoute
  '/exercise/$kind/level': typeof AppExerciseKindLevelRoute
  '/exercise/$kind/readback': typeof AppExerciseKindReadbackRoute
  '/groups/$id/chat': typeof AppGroupsIdChatRoute
  '/groups/$id/leave': typeof AppGroupsIdLeaveRoute
  '/groups/$id/report': typeof AppGroupsIdReportRoute
  '/invite/$inviteId/joined': typeof AppInviteInviteIdJoinedRoute
  '/library/book/$lineageUuid': typeof AppLibraryBookLineageUuidRoute
  '/library/math/$category': typeof AppLibraryMathCategoryRoute
  '/library/reading/$category': typeof AppLibraryReadingCategoryRoute
  '/exercise/$kind/': typeof AppExerciseKindIndexRoute
  '/account/groups/$id/delete': typeof AppAccountGroupsIdDeleteRoute
  '/account/groups/$id/facilitator': typeof AppAccountGroupsIdFacilitatorRoute
  '/account/groups/$id/invite': typeof AppAccountGroupsIdInviteRoute
  '/account/groups/$id/name': typeof AppAccountGroupsIdNameRoute
  '/account/groups/$id/people': typeof AppAccountGroupsIdPeopleRoute
  '/library/math/set/$lineageUuid': typeof AppLibraryMathSetLineageUuidRoute
  '/account/groups/$id/invite/access': typeof AppAccountGroupsIdInviteAccessRoute
  '/account/groups/$id/invite/sent': typeof AppAccountGroupsIdInviteSentRoute
  '/account/groups/$id/member/$personId': typeof AppAccountGroupsIdMemberPersonIdRoute
  '/account/groups/$id/invite/$inviteId/withdraw': typeof AppAccountGroupsIdInviteInviteIdWithdrawRoute
  '/account/groups/$id/member/$personId/access': typeof AppAccountGroupsIdMemberPersonIdAccessRoute
  '/account/groups/$id/member/$personId/remove': typeof AppAccountGroupsIdMemberPersonIdRemoveRoute
}
export interface FileRoutesByTo {
  '/about': typeof AboutRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/account': typeof AppAccountRoute
  '/friends': typeof AppFriendsRoute
  '/groups': typeof AppGroupsRoute
  '/library': typeof AppLibraryRoute
  '/progress': typeof AppProgressRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/': typeof AppIndexRoute
  '/account/about': typeof AppAccountAboutRoute
  '/account/groups': typeof AppAccountGroupsRoute
  '/account/help': typeof AppAccountHelpRoute
  '/account/reminders': typeof AppAccountRemindersRoute
  '/groups/$id': typeof AppGroupsIdRoute
  '/invite/$inviteId': typeof AppInviteInviteIdRoute
  '/account/groups/$id': typeof AppAccountGroupsIdRoute
  '/account/groups/new': typeof AppAccountGroupsNewRoute
  '/exercise/$kind/choose': typeof AppExerciseKindChooseRoute
  '/exercise/$kind/complete': typeof AppExerciseKindCompleteRoute
  '/exercise/$kind/intro': typeof AppExerciseKindIntroRoute
  '/exercise/$kind/level': typeof AppExerciseKindLevelRoute
  '/exercise/$kind/readback': typeof AppExerciseKindReadbackRoute
  '/groups/$id/chat': typeof AppGroupsIdChatRoute
  '/groups/$id/leave': typeof AppGroupsIdLeaveRoute
  '/groups/$id/report': typeof AppGroupsIdReportRoute
  '/invite/$inviteId/joined': typeof AppInviteInviteIdJoinedRoute
  '/library/book/$lineageUuid': typeof AppLibraryBookLineageUuidRoute
  '/library/math/$category': typeof AppLibraryMathCategoryRoute
  '/library/reading/$category': typeof AppLibraryReadingCategoryRoute
  '/exercise/$kind': typeof AppExerciseKindIndexRoute
  '/account/groups/$id/delete': typeof AppAccountGroupsIdDeleteRoute
  '/account/groups/$id/facilitator': typeof AppAccountGroupsIdFacilitatorRoute
  '/account/groups/$id/invite': typeof AppAccountGroupsIdInviteRoute
  '/account/groups/$id/name': typeof AppAccountGroupsIdNameRoute
  '/account/groups/$id/people': typeof AppAccountGroupsIdPeopleRoute
  '/library/math/set/$lineageUuid': typeof AppLibraryMathSetLineageUuidRoute
  '/account/groups/$id/invite/access': typeof AppAccountGroupsIdInviteAccessRoute
  '/account/groups/$id/invite/sent': typeof AppAccountGroupsIdInviteSentRoute
  '/account/groups/$id/member/$personId': typeof AppAccountGroupsIdMemberPersonIdRoute
  '/account/groups/$id/invite/$inviteId/withdraw': typeof AppAccountGroupsIdInviteInviteIdWithdrawRoute
  '/account/groups/$id/member/$personId/access': typeof AppAccountGroupsIdMemberPersonIdAccessRoute
  '/account/groups/$id/member/$personId/remove': typeof AppAccountGroupsIdMemberPersonIdRemoveRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/about': typeof AboutRoute
  '/onboarding': typeof OnboardingRoute
  '/sign-in': typeof SignInRoute
  '/welcome': typeof WelcomeRoute
  '/_app/account': typeof AppAccountRoute
  '/_app/friends': typeof AppFriendsRoute
  '/_app/groups': typeof AppGroupsRoute
  '/_app/library': typeof AppLibraryRoute
  '/_app/progress': typeof AppProgressRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/': typeof AppIndexRoute
  '/_app/account_/about': typeof AppAccountAboutRoute
  '/_app/account_/groups': typeof AppAccountGroupsRoute
  '/_app/account_/help': typeof AppAccountHelpRoute
  '/_app/account_/reminders': typeof AppAccountRemindersRoute
  '/_app/groups_/$id': typeof AppGroupsIdRoute
  '/_app/invite/$inviteId': typeof AppInviteInviteIdRoute
  '/_app/account_/groups_/$id': typeof AppAccountGroupsIdRoute
  '/_app/account_/groups_/new': typeof AppAccountGroupsNewRoute
  '/_app/exercise/$kind/choose': typeof AppExerciseKindChooseRoute
  '/_app/exercise/$kind/complete': typeof AppExerciseKindCompleteRoute
  '/_app/exercise/$kind/intro': typeof AppExerciseKindIntroRoute
  '/_app/exercise/$kind/level': typeof AppExerciseKindLevelRoute
  '/_app/exercise/$kind/readback': typeof AppExerciseKindReadbackRoute
  '/_app/groups_/$id_/chat': typeof AppGroupsIdChatRoute
  '/_app/groups_/$id_/leave': typeof AppGroupsIdLeaveRoute
  '/_app/groups_/$id_/report': typeof AppGroupsIdReportRoute
  '/_app/invite/$inviteId_/joined': typeof AppInviteInviteIdJoinedRoute
  '/_app/library_/book/$lineageUuid': typeof AppLibraryBookLineageUuidRoute
  '/_app/library_/math/$category': typeof AppLibraryMathCategoryRoute
  '/_app/library_/reading/$category': typeof AppLibraryReadingCategoryRoute
  '/_app/exercise/$kind/': typeof AppExerciseKindIndexRoute
  '/_app/account_/groups_/$id_/delete': typeof AppAccountGroupsIdDeleteRoute
  '/_app/account_/groups_/$id_/facilitator': typeof AppAccountGroupsIdFacilitatorRoute
  '/_app/account_/groups_/$id_/invite': typeof AppAccountGroupsIdInviteRoute
  '/_app/account_/groups_/$id_/name': typeof AppAccountGroupsIdNameRoute
  '/_app/account_/groups_/$id_/people': typeof AppAccountGroupsIdPeopleRoute
  '/_app/library_/math/set/$lineageUuid': typeof AppLibraryMathSetLineageUuidRoute
  '/_app/account_/groups_/$id_/invite_/access': typeof AppAccountGroupsIdInviteAccessRoute
  '/_app/account_/groups_/$id_/invite_/sent': typeof AppAccountGroupsIdInviteSentRoute
  '/_app/account_/groups_/$id_/member/$personId': typeof AppAccountGroupsIdMemberPersonIdRoute
  '/_app/account_/groups_/$id_/invite_/$inviteId/withdraw': typeof AppAccountGroupsIdInviteInviteIdWithdrawRoute
  '/_app/account_/groups_/$id_/member/$personId_/access': typeof AppAccountGroupsIdMemberPersonIdAccessRoute
  '/_app/account_/groups_/$id_/member/$personId_/remove': typeof AppAccountGroupsIdMemberPersonIdRemoveRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/onboarding'
    | '/sign-in'
    | '/welcome'
    | '/account'
    | '/friends'
    | '/groups'
    | '/library'
    | '/progress'
    | '/auth/callback'
    | '/account/about'
    | '/account/groups'
    | '/account/help'
    | '/account/reminders'
    | '/groups/$id'
    | '/invite/$inviteId'
    | '/account/groups/$id'
    | '/account/groups/new'
    | '/exercise/$kind/choose'
    | '/exercise/$kind/complete'
    | '/exercise/$kind/intro'
    | '/exercise/$kind/level'
    | '/exercise/$kind/readback'
    | '/groups/$id/chat'
    | '/groups/$id/leave'
    | '/groups/$id/report'
    | '/invite/$inviteId/joined'
    | '/library/book/$lineageUuid'
    | '/library/math/$category'
    | '/library/reading/$category'
    | '/exercise/$kind/'
    | '/account/groups/$id/delete'
    | '/account/groups/$id/facilitator'
    | '/account/groups/$id/invite'
    | '/account/groups/$id/name'
    | '/account/groups/$id/people'
    | '/library/math/set/$lineageUuid'
    | '/account/groups/$id/invite/access'
    | '/account/groups/$id/invite/sent'
    | '/account/groups/$id/member/$personId'
    | '/account/groups/$id/invite/$inviteId/withdraw'
    | '/account/groups/$id/member/$personId/access'
    | '/account/groups/$id/member/$personId/remove'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/about'
    | '/onboarding'
    | '/sign-in'
    | '/welcome'
    | '/account'
    | '/friends'
    | '/groups'
    | '/library'
    | '/progress'
    | '/auth/callback'
    | '/'
    | '/account/about'
    | '/account/groups'
    | '/account/help'
    | '/account/reminders'
    | '/groups/$id'
    | '/invite/$inviteId'
    | '/account/groups/$id'
    | '/account/groups/new'
    | '/exercise/$kind/choose'
    | '/exercise/$kind/complete'
    | '/exercise/$kind/intro'
    | '/exercise/$kind/level'
    | '/exercise/$kind/readback'
    | '/groups/$id/chat'
    | '/groups/$id/leave'
    | '/groups/$id/report'
    | '/invite/$inviteId/joined'
    | '/library/book/$lineageUuid'
    | '/library/math/$category'
    | '/library/reading/$category'
    | '/exercise/$kind'
    | '/account/groups/$id/delete'
    | '/account/groups/$id/facilitator'
    | '/account/groups/$id/invite'
    | '/account/groups/$id/name'
    | '/account/groups/$id/people'
    | '/library/math/set/$lineageUuid'
    | '/account/groups/$id/invite/access'
    | '/account/groups/$id/invite/sent'
    | '/account/groups/$id/member/$personId'
    | '/account/groups/$id/invite/$inviteId/withdraw'
    | '/account/groups/$id/member/$personId/access'
    | '/account/groups/$id/member/$personId/remove'
  id:
    | '__root__'
    | '/_app'
    | '/about'
    | '/onboarding'
    | '/sign-in'
    | '/welcome'
    | '/_app/account'
    | '/_app/friends'
    | '/_app/groups'
    | '/_app/library'
    | '/_app/progress'
    | '/auth/callback'
    | '/_app/'
    | '/_app/account_/about'
    | '/_app/account_/groups'
    | '/_app/account_/help'
    | '/_app/account_/reminders'
    | '/_app/groups_/$id'
    | '/_app/invite/$inviteId'
    | '/_app/account_/groups_/$id'
    | '/_app/account_/groups_/new'
    | '/_app/exercise/$kind/choose'
    | '/_app/exercise/$kind/complete'
    | '/_app/exercise/$kind/intro'
    | '/_app/exercise/$kind/level'
    | '/_app/exercise/$kind/readback'
    | '/_app/groups_/$id_/chat'
    | '/_app/groups_/$id_/leave'
    | '/_app/groups_/$id_/report'
    | '/_app/invite/$inviteId_/joined'
    | '/_app/library_/book/$lineageUuid'
    | '/_app/library_/math/$category'
    | '/_app/library_/reading/$category'
    | '/_app/exercise/$kind/'
    | '/_app/account_/groups_/$id_/delete'
    | '/_app/account_/groups_/$id_/facilitator'
    | '/_app/account_/groups_/$id_/invite'
    | '/_app/account_/groups_/$id_/name'
    | '/_app/account_/groups_/$id_/people'
    | '/_app/library_/math/set/$lineageUuid'
    | '/_app/account_/groups_/$id_/invite_/access'
    | '/_app/account_/groups_/$id_/invite_/sent'
    | '/_app/account_/groups_/$id_/member/$personId'
    | '/_app/account_/groups_/$id_/invite_/$inviteId/withdraw'
    | '/_app/account_/groups_/$id_/member/$personId_/access'
    | '/_app/account_/groups_/$id_/member/$personId_/remove'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AboutRoute: typeof AboutRoute
  OnboardingRoute: typeof OnboardingRoute
  SignInRoute: typeof SignInRoute
  WelcomeRoute: typeof WelcomeRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account': {
      id: '/_app/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AppAccountRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/friends': {
      id: '/_app/friends'
      path: '/friends'
      fullPath: '/friends'
      preLoaderRoute: typeof AppFriendsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups': {
      id: '/_app/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library': {
      id: '/_app/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof AppLibraryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/progress': {
      id: '/_app/progress'
      path: '/progress'
      fullPath: '/progress'
      preLoaderRoute: typeof AppProgressRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/account_/about': {
      id: '/_app/account_/about'
      path: '/account/about'
      fullPath: '/account/about'
      preLoaderRoute: typeof AppAccountAboutRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups': {
      id: '/_app/account_/groups'
      path: '/account/groups'
      fullPath: '/account/groups'
      preLoaderRoute: typeof AppAccountGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/help': {
      id: '/_app/account_/help'
      path: '/account/help'
      fullPath: '/account/help'
      preLoaderRoute: typeof AppAccountHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/reminders': {
      id: '/_app/account_/reminders'
      path: '/account/reminders'
      fullPath: '/account/reminders'
      preLoaderRoute: typeof AppAccountRemindersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups_/$id': {
      id: '/_app/groups_/$id'
      path: '/groups/$id'
      fullPath: '/groups/$id'
      preLoaderRoute: typeof AppGroupsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/$inviteId': {
      id: '/_app/invite/$inviteId'
      path: '/invite/$inviteId'
      fullPath: '/invite/$inviteId'
      preLoaderRoute: typeof AppInviteInviteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id': {
      id: '/_app/account_/groups_/$id'
      path: '/account/groups/$id'
      fullPath: '/account/groups/$id'
      preLoaderRoute: typeof AppAccountGroupsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/new': {
      id: '/_app/account_/groups_/new'
      path: '/account/groups/new'
      fullPath: '/account/groups/new'
      preLoaderRoute: typeof AppAccountGroupsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/': {
      id: '/_app/exercise/$kind/'
      path: '/exercise/$kind'
      fullPath: '/exercise/$kind/'
      preLoaderRoute: typeof AppExerciseKindIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/choose': {
      id: '/_app/exercise/$kind/choose'
      path: '/exercise/$kind/choose'
      fullPath: '/exercise/$kind/choose'
      preLoaderRoute: typeof AppExerciseKindChooseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/complete': {
      id: '/_app/exercise/$kind/complete'
      path: '/exercise/$kind/complete'
      fullPath: '/exercise/$kind/complete'
      preLoaderRoute: typeof AppExerciseKindCompleteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/intro': {
      id: '/_app/exercise/$kind/intro'
      path: '/exercise/$kind/intro'
      fullPath: '/exercise/$kind/intro'
      preLoaderRoute: typeof AppExerciseKindIntroRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/level': {
      id: '/_app/exercise/$kind/level'
      path: '/exercise/$kind/level'
      fullPath: '/exercise/$kind/level'
      preLoaderRoute: typeof AppExerciseKindLevelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exercise/$kind/readback': {
      id: '/_app/exercise/$kind/readback'
      path: '/exercise/$kind/readback'
      fullPath: '/exercise/$kind/readback'
      preLoaderRoute: typeof AppExerciseKindReadbackRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups_/$id_/chat': {
      id: '/_app/groups_/$id_/chat'
      path: '/groups/$id/chat'
      fullPath: '/groups/$id/chat'
      preLoaderRoute: typeof AppGroupsIdChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups_/$id_/leave': {
      id: '/_app/groups_/$id_/leave'
      path: '/groups/$id/leave'
      fullPath: '/groups/$id/leave'
      preLoaderRoute: typeof AppGroupsIdLeaveRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups_/$id_/report': {
      id: '/_app/groups_/$id_/report'
      path: '/groups/$id/report'
      fullPath: '/groups/$id/report'
      preLoaderRoute: typeof AppGroupsIdReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invite/$inviteId_/joined': {
      id: '/_app/invite/$inviteId_/joined'
      path: '/invite/$inviteId/joined'
      fullPath: '/invite/$inviteId/joined'
      preLoaderRoute: typeof AppInviteInviteIdJoinedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/book/$lineageUuid': {
      id: '/_app/library_/book/$lineageUuid'
      path: '/library/book/$lineageUuid'
      fullPath: '/library/book/$lineageUuid'
      preLoaderRoute: typeof AppLibraryBookLineageUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/math/$category': {
      id: '/_app/library_/math/$category'
      path: '/library/math/$category'
      fullPath: '/library/math/$category'
      preLoaderRoute: typeof AppLibraryMathCategoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/reading/$category': {
      id: '/_app/library_/reading/$category'
      path: '/library/reading/$category'
      fullPath: '/library/reading/$category'
      preLoaderRoute: typeof AppLibraryReadingCategoryRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/delete': {
      id: '/_app/account_/groups_/$id_/delete'
      path: '/account/groups/$id/delete'
      fullPath: '/account/groups/$id/delete'
      preLoaderRoute: typeof AppAccountGroupsIdDeleteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/facilitator': {
      id: '/_app/account_/groups_/$id_/facilitator'
      path: '/account/groups/$id/facilitator'
      fullPath: '/account/groups/$id/facilitator'
      preLoaderRoute: typeof AppAccountGroupsIdFacilitatorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/invite': {
      id: '/_app/account_/groups_/$id_/invite'
      path: '/account/groups/$id/invite'
      fullPath: '/account/groups/$id/invite'
      preLoaderRoute: typeof AppAccountGroupsIdInviteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/name': {
      id: '/_app/account_/groups_/$id_/name'
      path: '/account/groups/$id/name'
      fullPath: '/account/groups/$id/name'
      preLoaderRoute: typeof AppAccountGroupsIdNameRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/people': {
      id: '/_app/account_/groups_/$id_/people'
      path: '/account/groups/$id/people'
      fullPath: '/account/groups/$id/people'
      preLoaderRoute: typeof AppAccountGroupsIdPeopleRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/library_/math/set/$lineageUuid': {
      id: '/_app/library_/math/set/$lineageUuid'
      path: '/library/math/set/$lineageUuid'
      fullPath: '/library/math/set/$lineageUuid'
      preLoaderRoute: typeof AppLibraryMathSetLineageUuidRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/invite_/access': {
      id: '/_app/account_/groups_/$id_/invite_/access'
      path: '/account/groups/$id/invite/access'
      fullPath: '/account/groups/$id/invite/access'
      preLoaderRoute: typeof AppAccountGroupsIdInviteAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/invite_/sent': {
      id: '/_app/account_/groups_/$id_/invite_/sent'
      path: '/account/groups/$id/invite/sent'
      fullPath: '/account/groups/$id/invite/sent'
      preLoaderRoute: typeof AppAccountGroupsIdInviteSentRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/member/$personId': {
      id: '/_app/account_/groups_/$id_/member/$personId'
      path: '/account/groups/$id/member/$personId'
      fullPath: '/account/groups/$id/member/$personId'
      preLoaderRoute: typeof AppAccountGroupsIdMemberPersonIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/invite_/$inviteId/withdraw': {
      id: '/_app/account_/groups_/$id_/invite_/$inviteId/withdraw'
      path: '/account/groups/$id/invite/$inviteId/withdraw'
      fullPath: '/account/groups/$id/invite/$inviteId/withdraw'
      preLoaderRoute: typeof AppAccountGroupsIdInviteInviteIdWithdrawRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/member/$personId_/access': {
      id: '/_app/account_/groups_/$id_/member/$personId_/access'
      path: '/account/groups/$id/member/$personId/access'
      fullPath: '/account/groups/$id/member/$personId/access'
      preLoaderRoute: typeof AppAccountGroupsIdMemberPersonIdAccessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/account_/groups_/$id_/member/$personId_/remove': {
      id: '/_app/account_/groups_/$id_/member/$personId_/remove'
      path: '/account/groups/$id/member/$personId/remove'
      fullPath: '/account/groups/$id/member/$personId/remove'
      preLoaderRoute: typeof AppAccountGroupsIdMemberPersonIdRemoveRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountRoute: typeof AppAccountRoute
  AppFriendsRoute: typeof AppFriendsRoute
  AppGroupsRoute: typeof AppGroupsRoute
  AppLibraryRoute: typeof AppLibraryRoute
  AppProgressRoute: typeof AppProgressRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAccountAboutRoute: typeof AppAccountAboutRoute
  AppAccountGroupsRoute: typeof AppAccountGroupsRoute
  AppAccountHelpRoute: typeof AppAccountHelpRoute
  AppAccountRemindersRoute: typeof AppAccountRemindersRoute
  AppGroupsIdRoute: typeof AppGroupsIdRoute
  AppInviteInviteIdRoute: typeof AppInviteInviteIdRoute
  AppAccountGroupsIdRoute: typeof AppAccountGroupsIdRoute
  AppAccountGroupsNewRoute: typeof AppAccountGroupsNewRoute
  AppExerciseKindChooseRoute: typeof AppExerciseKindChooseRoute
  AppExerciseKindCompleteRoute: typeof AppExerciseKindCompleteRoute
  AppExerciseKindIntroRoute: typeof AppExerciseKindIntroRoute
  AppExerciseKindLevelRoute: typeof AppExerciseKindLevelRoute
  AppExerciseKindReadbackRoute: typeof AppExerciseKindReadbackRoute
  AppGroupsIdChatRoute: typeof AppGroupsIdChatRoute
  AppGroupsIdLeaveRoute: typeof AppGroupsIdLeaveRoute
  AppGroupsIdReportRoute: typeof AppGroupsIdReportRoute
  AppInviteInviteIdJoinedRoute: typeof AppInviteInviteIdJoinedRoute
  AppLibraryBookLineageUuidRoute: typeof AppLibraryBookLineageUuidRoute
  AppLibraryMathCategoryRoute: typeof AppLibraryMathCategoryRoute
  AppLibraryReadingCategoryRoute: typeof AppLibraryReadingCategoryRoute
  AppExerciseKindIndexRoute: typeof AppExerciseKindIndexRoute
  AppAccountGroupsIdDeleteRoute: typeof AppAccountGroupsIdDeleteRoute
  AppAccountGroupsIdFacilitatorRoute: typeof AppAccountGroupsIdFacilitatorRoute
  AppAccountGroupsIdInviteRoute: typeof AppAccountGroupsIdInviteRoute
  AppAccountGroupsIdNameRoute: typeof AppAccountGroupsIdNameRoute
  AppAccountGroupsIdPeopleRoute: typeof AppAccountGroupsIdPeopleRoute
  AppLibraryMathSetLineageUuidRoute: typeof AppLibraryMathSetLineageUuidRoute
  AppAccountGroupsIdInviteAccessRoute: typeof AppAccountGroupsIdInviteAccessRoute
  AppAccountGroupsIdInviteSentRoute: typeof AppAccountGroupsIdInviteSentRoute
  AppAccountGroupsIdMemberPersonIdRoute: typeof AppAccountGroupsIdMemberPersonIdRoute
  AppAccountGroupsIdInviteInviteIdWithdrawRoute: typeof AppAccountGroupsIdInviteInviteIdWithdrawRoute
  AppAccountGroupsIdMemberPersonIdAccessRoute: typeof AppAccountGroupsIdMemberPersonIdAccessRoute
  AppAccountGroupsIdMemberPersonIdRemoveRoute: typeof AppAccountGroupsIdMemberPersonIdRemoveRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountRoute: AppAccountRoute,
  AppFriendsRoute: AppFriendsRoute,
  AppGroupsRoute: AppGroupsRoute,
  AppLibraryRoute: AppLibraryRoute,
  AppProgressRoute: AppProgressRoute,
  AppIndexRoute: AppIndexRoute,
  AppAccountAboutRoute: AppAccountAboutRoute,
  AppAccountGroupsRoute: AppAccountGroupsRoute,
  AppAccountHelpRoute: AppAccountHelpRoute,
  AppAccountRemindersRoute: AppAccountRemindersRoute,
  AppGroupsIdRoute: AppGroupsIdRoute,
  AppInviteInviteIdRoute: AppInviteInviteIdRoute,
  AppAccountGroupsIdRoute: AppAccountGroupsIdRoute,
  AppAccountGroupsNewRoute: AppAccountGroupsNewRoute,
  AppExerciseKindChooseRoute: AppExerciseKindChooseRoute,
  AppExerciseKindCompleteRoute: AppExerciseKindCompleteRoute,
  AppExerciseKindIntroRoute: AppExerciseKindIntroRoute,
  AppExerciseKindLevelRoute: AppExerciseKindLevelRoute,
  AppExerciseKindReadbackRoute: AppExerciseKindReadbackRoute,
  AppGroupsIdChatRoute: AppGroupsIdChatRoute,
  AppGroupsIdLeaveRoute: AppGroupsIdLeaveRoute,
  AppGroupsIdReportRoute: AppGroupsIdReportRoute,
  AppInviteInviteIdJoinedRoute: AppInviteInviteIdJoinedRoute,
  AppLibraryBookLineageUuidRoute: AppLibraryBookLineageUuidRoute,
  AppLibraryMathCategoryRoute: AppLibraryMathCategoryRoute,
  AppLibraryReadingCategoryRoute: AppLibraryReadingCategoryRoute,
  AppExerciseKindIndexRoute: AppExerciseKindIndexRoute,
  AppAccountGroupsIdDeleteRoute: AppAccountGroupsIdDeleteRoute,
  AppAccountGroupsIdFacilitatorRoute: AppAccountGroupsIdFacilitatorRoute,
  AppAccountGroupsIdInviteRoute: AppAccountGroupsIdInviteRoute,
  AppAccountGroupsIdNameRoute: AppAccountGroupsIdNameRoute,
  AppAccountGroupsIdPeopleRoute: AppAccountGroupsIdPeopleRoute,
  AppLibraryMathSetLineageUuidRoute: AppLibraryMathSetLineageUuidRoute,
  AppAccountGroupsIdInviteAccessRoute: AppAccountGroupsIdInviteAccessRoute,
  AppAccountGroupsIdInviteSentRoute: AppAccountGroupsIdInviteSentRoute,
  AppAccountGroupsIdMemberPersonIdRoute: AppAccountGroupsIdMemberPersonIdRoute,
  AppAccountGroupsIdInviteInviteIdWithdrawRoute:
    AppAccountGroupsIdInviteInviteIdWithdrawRoute,
  AppAccountGroupsIdMemberPersonIdAccessRoute:
    AppAccountGroupsIdMemberPersonIdAccessRoute,
  AppAccountGroupsIdMemberPersonIdRemoveRoute:
    AppAccountGroupsIdMemberPersonIdRemoveRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AboutRoute: AboutRoute,
  OnboardingRoute: OnboardingRoute,
  SignInRoute: SignInRoute,
  WelcomeRoute: WelcomeRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
